import { getVar } from "config";

export const GIPHY_SDK_KEY = getVar("REACT_APP_GIPHY_SDK_KEY");
